import React from "react";
import AllToolTip from "../../Tooltip/AllToolTips";

const ModalWrapper = ({
  name,
  id = "modalDefault",
  children,
  extraClasses,
  tooltipText,
}) => {
  return (
    <>
      <div
        className="modal fade"
        id={id}
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby={`${id}Label`}
        aria-hidden="true"
      >
        <div
          className={`modal-dialog modal-dialog-centered ${extraClasses}`}
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header bg-gray-700 min-h-auto">
              <div className="d-flex align-items-center">
                <h5 className="modal-title text-white">{name}</h5>
                {tooltipText && <AllToolTip text={tooltipText} />}
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" className="ki ki-close text-white"></i>
              </button>
            </div>

            <div className="modal-body" id="ant_inputs">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalWrapper;
